import { useEffect, useState } from 'react';
import Body from './components/Body/Body';
import './assets/css/common.scss';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  useEffect(()=>{
    setTimeout(()=>{
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },1000)
    })

  return (
    <div className="App">
        <Body>

        </Body>
        <ToastContainer />
    </div>
  );
}

export default App;
